module.exports = __webpack_public_path__ + "static/media/29820016-TrC0wSgs.20a726a9.JPG";